<template>
  <div>
      <!-- {{languageMode}} -->
      <!--Edit by ankit-->
        <a class="mdc-list-item d-flex justify-content-between align-items-center" tabindex="0" @click="toggleLanguageSelect()" @keypress="toggleLanguageSelect()">
            <i class="material-icons mdc-list-item__graphic">language</i>
            <div class="flex-grow-1">
                {{$t('2058')}}
            </div>
            
            <!-- 언어선택 -->
            <i class="material-icons">
                {{!isLanguageSelect ? 'expand_more' : 'expand_less' }}
            </i>
        </a>
        <transition name="slide">
            <div v-if="isLanguageSelect">
                <!-- <input v-model="search"/> -->
                <!-- <a v-for="(language, index) in searchLang()" :key="index" class="mdc-list-item" @click="changeLanguage(language)">
                    <i class="material-icons mdc-list-item__graphic"></i>
                    {{language.text}}
                </a> -->

                <a v-for="(language, index) in languageList" :key="index" class="mdc-list-item" tabindex="0" @click="changeLanguage(language)" @keypress="changeLanguage(language)">
                    <i class="material-icons mdc-list-item__graphic"></i>
                    {{language.text}}
                </a>
            </div>
        </transition>
    </div>
</template>

<script>
/**
 * 네비게이션 드로워 언어 목록 컴포넌트(navigation drawer language list Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import i18nApi from '@/api/i18nApi.js'
import { setUserLanguage } from '@/translations/i18nSetup'
import {mapState, mapMutations} from 'vuex'

export default {
    data() {
        return {
            isLanguageSelect: false,
            languageList: [],
            search: ''
        }
    },

    computed: {
        ...mapState([
            'languageMode'
        ])
    },

    mounted() {
        let params = {
            brandCode: localStorage.getItem('brandCode')
        }

        if (localStorage.getItem('brandCode')) {
            // 브랜드 언어 목록 가져오기(get service language list)
            i18nApi.guestLanguagePack(params).then((response) => {
                this.languageList = response.data.data
            })
        }
    },

    methods: {
        ...mapMutations(['SET_LANGUAGE_MODE']),
        // 언어 목록 토글(toggle language list)
        toggleLanguageSelect() {
            this.isLanguageSelect = !this.isLanguageSelect
        },
        // 언어 변경(change language)
        changeLanguage(lang){
            setUserLanguage(lang.code).then(() => {
                this.$emit('closeDrawer')
            })
        },
        searchLang() {
            
            return this.languageList.filter((lang) => {
                return lang.code.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
            })
        }
    }
}
</script>